/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import CalendarPricingMobile from './CalendarPricingMobile/CalendarPricingMobile';
import { useDispatch, useSelector } from 'react-redux';
import { addCommas } from '@persian-tools/persian-tools';
import { CalendarPricingType } from '@/components/houses/_hooks/useProduct';
import { setBasicFilters } from '@/redux/store/actions/search';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Button from '@/components/UI/button/Button';
import Icon from '@/components/UI/icon/Icon';
import Drawer from '@/components/UI/drawer/Drawer';
import PeopleCount from '@/components/houses/housesDesktop/peopleCount/PeopleCount';
import Factor from '@/components/houses/housesDesktop/factor/Factor';
import heap from '@/helpers/heap';
import styles from './PriceBoxDrawer.module.scss';
import { RulesRecords } from '../../_types/productItem.types';
import Alert from '@/components/UI/alert/Alert';
type IPriceBoxDrawer = {
  rules: RulesRecords;
  id: number;
  isOpenDrawer: boolean;
  calendarPricing: CalendarPricingType;
  onSendReserveRequestClick: any;
  handleClose: () => void;
  blink?: any;
  loading: boolean;
};
const PriceBoxDrawer = ({
  rules,
  id,
  isOpenDrawer,
  calendarPricing,
  onSendReserveRequestClick,
  handleClose,
  blink,
  loading
}: IPriceBoxDrawer) => {
  const weekCalendarRef = React.createRef();
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const dispatch = useDispatch();
  const boxRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);
  const [hasInstant, setHasInstant] = React.useState(false);
  const proformaState = useSelector(state => state.proforma);
  const {
    total_payable_amount
  } = proformaState?.data || {};
  const textToShow = !checkout && guests == 0 ? 'تاریخ و نفرات را انتخاب کنید' : checkout && !guests ? 'نفرات را انتخاب کنید' : Number(guests) > 0 && !checkout ? 'تاریخ را انتخاب کنید ' : 'مبلغ کل رزرو';
  const setGuests = (value: number) => dispatch(setBasicFilters({
    checkin,
    checkout,
    guests: value
  }));
  const handleReservatinAction = () => {
    if (checkin && checkout && !guests) {
      heap.track('reserve_request:missingGuestCount', {
        house_id: id
      });
      setOpen(true);
      setTimeout(() => {
        setOpen(false);
      }, 3000);
    } else {
      onSendReserveRequestClick();
    }
  };
  const maxCheckin = `${rules?.checkin} ${rules?.max_checkin_time ? `تا ${rules?.max_checkin_time}` : ''}`;
  const minCheckout = rules?.checkout;
  useEffect(() => {
    if (!!calendarPricing?.houseCalendarData?.today && !checkout) {
      setHasInstant(true);
    } else {
      setHasInstant(false);
    }
    if (!!checkin && !!checkout && guests) {
      setTimeout(() => {
        boxRef.current?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    }
  }, [checkin, checkout, guests, calendarPricing?.houseCalendarData?.today]);
  return <Drawer anchor="bottom" fullHeight open={isOpenDrawer} onClose={() => handleClose()} data-sentry-element="Drawer" data-sentry-component="PriceBoxDrawer" data-sentry-source-file="PriceBoxDrawer.tsx">
      <Box className={styles['pricebox']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
        <Box className={styles['pricebox-header']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
          <Box className={styles['pricebox-header-back']} onClick={() => handleClose()} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
            <Icon type={'secondary'} name={'arrow-right-1'} data-sentry-element="Icon" data-sentry-source-file="PriceBoxDrawer.tsx"></Icon>
          </Box>
          <Typography variant="bodyL_Bold" color="neutral_700" data-sentry-element="Typography" data-sentry-source-file="PriceBoxDrawer.tsx">
            جزییات رزرو
          </Typography>
        </Box>

        <Box className={styles['pricebox-main']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
          <Box className={styles['pricebox-main-calendar']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
            <CalendarPricingMobile hookData={calendarPricing} calendarRef={weekCalendarRef} hasInstant={true} data-sentry-element="CalendarPricingMobile" data-sentry-source-file="PriceBoxDrawer.tsx" />
          </Box>
          <Box className={styles['pricebox-main-counter']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
            <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="PriceBoxDrawer.tsx">انتخاب نفرات</Typography>
            <PeopleCount guests={+guests} setGuests={setGuests} maxAccommodates={rules?.max_accommodates} rules={rules} blink={blink} data-sentry-element="PeopleCount" data-sentry-source-file="PriceBoxDrawer.tsx" />
            <Box className={styles['pricebox-main-counter-error']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
              {open && <Alert title={'لطفا نفرات را انتخاب کنید'} type={'error'} className={styles['pricebox-main-counter-error-alert']} />}
            </Box>
          </Box>
          {!!checkin && !!checkout && !!guests && <Box ref={boxRef} className={styles['pricebox-main-factor']}>
              <Factor checkin={checkin} checkout={checkout} proformaState={proformaState} maxCheckin={maxCheckin} minCheckout={minCheckout} />
            </Box>}
        </Box>

        <Box className={styles['pricebox-footer']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
          <Box className={styles['pricebox-footer-info']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
            <Typography component="p" variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="PriceBoxDrawer.tsx">
              {textToShow}
            </Typography>
            {!!checkout && Number(guests) > 0 && <Typography component="p" variant="bodyL">
                {`${addCommas(total_payable_amount?.final_price || 0)}  
                  ${'تومان'}`}
              </Typography>}
          </Box>
          <Box className={styles['pricebox-footer-action']} data-sentry-element="Box" data-sentry-source-file="PriceBoxDrawer.tsx">
            <Button format="primary" size="large" onClick={handleReservatinAction} disabled={!checkin || !checkout || loading} data-sentry-element="Button" data-sentry-source-file="PriceBoxDrawer.tsx">
              {hasInstant ? 'ثبت رزرو' : 'ارسال درخواست رزرو'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>;
};
export default PriceBoxDrawer;